import { useState, useEffect, useCallback, useRef } from 'react';

const useInfiniteScroll = callback => {
  const [isFetching, setIsFetching] = useState(false);
  const throttleTimeout = useRef(null);

  const fetchMoreData = useCallback(async () => {
    if (callback && typeof callback === 'function') {
      await callback();
    }
    setIsFetching(false);
  }, [callback]);

  useEffect(() => {
    if (!isFetching) return;
    fetchMoreData();
  }, [isFetching, fetchMoreData]);

  const handleScroll = useCallback(() => {
    if (throttleTimeout.current) {
      return;
    }

    throttleTimeout.current = setTimeout(() => {
      const scroller = document.getElementById('scroller');
      if (!scroller) {
        console.warn('Elemento scroller não encontrado');
        throttleTimeout.current = null;
        return;
      }

      const scrollTop = scroller.scrollTop;
      const scrollHeight = scroller.scrollHeight;
      const clientHeight = scroller.clientHeight;

      const threshold = 200;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (isNearBottom && !isFetching) {
        setIsFetching(true);
      }

      throttleTimeout.current = null;
    }, 150);
  }, [isFetching]);

  useEffect(() => {
    const scroller = document.getElementById('scroller');
    if (!scroller) {
      return;
    }

    scroller.addEventListener('scroll', handleScroll);

    return () => {
      scroller.removeEventListener('scroll', handleScroll);
      if (throttleTimeout.current) {
        clearTimeout(throttleTimeout.current);
        throttleTimeout.current = null;
      }
    };
  }, [handleScroll]);

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
